import { useParams } from 'react-router-dom';
import InsuranceContractTypesDetails from './components/insuranceContractTypesDetails/InsuranceContractTypesDetails';
import InsuranceContractTypesList from './components/insuranceContractTypesList/InsuranceContractTypesList';
import styles from './InsuranceContractTypesTab.module.scss';

const InsuranceContractTypesTab = () => {
    const { type } = useParams<{ type: string, itemId: string }>();

    return <div className={styles.container}>
        {
            (type === 'list' ? <InsuranceContractTypesList /> : <InsuranceContractTypesDetails />)
        }
        </div>;
}

export default InsuranceContractTypesTab;
